export default "__VITE_ASSET__BTObpSrr__"